<mat-toolbar class="mat-elevation-z8">
  {{ 'SHUTTLE_PLANNING_PAGE.PLAN_DETAILS' | transloco }}
  {{ formatDate($safeNavigationMigration(orderShuttleArrivalDeparture?.orderShuttlePlanRows[0]?.arrivalDepartureDate)) }}
</mat-toolbar>

<mat-dialog-content class="mt-3">
  <div class="mb-4">
    <table class="custom-table col-xs-6" mat-table [dataSource]="[orderShuttleArrivalDeparture]">
      <ng-container matColumnDef="totalOrders">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.ORDERS' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.totalOrders}} </td>
      </ng-container>

      <ng-container matColumnDef="totalPassengers">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.PERSONS' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.totalPassengers}} </td>
      </ng-container>

      <ng-container matColumnDef="totalBaggage">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.BAGGAGE' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.totalBaggage}} </td>
      </ng-container>

      <ng-container matColumnDef="totalChildseats">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.INFANTS' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.totalChildseats}} </td>
      </ng-container>

      <ng-container matColumnDef="totalCars">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.VEHICLES' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.totalCars}} </td>
      </ng-container>

      <ng-container matColumnDef="totalFlights">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.FLIGHTS' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.totalFlights}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsShuttle"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsShuttle"></tr>
    </table>
  </div>

  <div class="mb-4">
    <p><strong>{{ 'SHUTTLE_PLANNING_PAGE.PARKING_CUSTOMERS_WITH_CARS' |
        transloco }}:</strong> {{ totalPassengersWithCars }} persons</p>
    <p><strong>{{ 'SHUTTLE_PLANNING_PAGE.TRANSFER_CUSTOMERS_FROM_HOTELS' |
        transloco }}:</strong> {{ totalPassengersWithoutCars }} persons</p>
  </div>

  <div class="mb-3">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'TRANSACTION.FILTER.TITLE' | transloco }}</mat-label>
      <mat-select [(ngModel)]="carFilter">
        <mat-option value="all">{{ 'CHECKIN_CHECKOUT.FILTER_OPTIONS.ALL' | transloco }}</mat-option>
        <mat-option value="with-cars">{{ 'SHUTTLE_PLANNING_PAGE.PARKING_CUSTOMERS_WITH_CARS' |
          transloco }}</mat-option>
        <mat-option value="without-cars">{{ 'SHUTTLE_PLANNING_PAGE.TRANSFER_CUSTOMERS_FROM_HOTELS' |
          transloco }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="custom-table-container">
    <table class="custom-table col-xs-6" mat-table [dataSource]="filteredOrderRows">
      <ng-container matColumnDef="arrivalDepartureDate">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.DATE' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{ formatTime(element.arrivalDepartureDate) }} </td>
      </ng-container>

      <ng-container matColumnDef="passengers">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.PERSONS' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.passengers}} </td>
      </ng-container>

      <ng-container matColumnDef="baggage">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.BAGGAGE' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.baggage}} </td>
      </ng-container>

      <ng-container matColumnDef="childseats">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.INFANTS' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.childseats}} </td>
      </ng-container>

      <ng-container matColumnDef="cars">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.VEHICLES' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.cars}} </td>
      </ng-container>

      <ng-container matColumnDef="flightNr">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.FLIGHT_NUMBER' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.flightNr}} </td>
      </ng-container>

      <ng-container matColumnDef="terminal">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.TERMINAL' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.terminal}} </td>
      </ng-container>

      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.ORDER_NUMBER' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.orderNr}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsOrders"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsOrders;" (click)="goToOrder(row.orderId)"
        [style.cursor]="'pointer'"></tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="px-4 pb-4" align="end">
  <button mat-button mat-dialog-close>{{ 'FORM.TERMSDIALOGCLOSE' | transloco}}</button>
</mat-dialog-actions>